if (!customElements.get('blog-grid')) {
  customElements.define(
    'blog-grid',
    class BlogGrid extends HTMLElement {
      constructor() {
        super();
        this.filterButtons = this.querySelectorAll('[data-filter]');
        this.articles = this.querySelectorAll('.blog-grid__article');
        this.loadMoreBtn = this.querySelector('[data-load-more-btn]');
        this.gridContainer = this.querySelector('[data-blog-grid-container]');
        this.currentFilter = 'all';
      }

      connectedCallback() {
        this.initFilters();
        this.initLoadMore();
      }

      initFilters() {
        this.filterButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const filter = btn.getAttribute('data-filter');
            this.filterArticles(filter);
            this.updateActiveFilter(btn);
          });
        });
      }

      filterArticles(filter) {
        this.currentFilter = filter;

        this.articles.forEach((article) => {
          const tags = article.getAttribute('data-tags') || '';
          const tagsArray = tags.split(' ').filter((t) => t);

          if (filter === 'all' || tagsArray.includes(filter)) {
            article.classList.remove('is-hidden');
          } else {
            article.classList.add('is-hidden');
          }
        });
      }

      updateActiveFilter(activeBtn) {
        this.filterButtons.forEach((btn) => {
          btn.classList.remove('is-active');
        });
        activeBtn.classList.add('is-active');
      }

      initLoadMore() {
        if (!this.loadMoreBtn) return;

        this.loadMoreBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.loadMore();
        });
      }

      async loadMore() {
        const nextUrl = this.loadMoreBtn.getAttribute('data-next-url');
        if (!nextUrl) return;

        this.loadMoreBtn.classList.add('is-loading');
        this.loadMoreBtn.disabled = true;

        try {
          const response = await fetch(nextUrl);
          if (!response.ok) throw new Error('Network response was not ok');

          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Get new articles
          const newArticles = doc.querySelectorAll('.blog-grid__article');
          newArticles.forEach((article) => {
            this.gridContainer.appendChild(article.cloneNode(true));
          });

          // Update articles reference
          this.articles = this.querySelectorAll('.blog-grid__article');

          // Apply current filter to new articles
          if (this.currentFilter !== 'all') {
            this.filterArticles(this.currentFilter);
          }

          // Check for next page
          const newLoadMoreBtn = doc.querySelector('[data-load-more-btn]');
          if (newLoadMoreBtn) {
            const newNextUrl = newLoadMoreBtn.getAttribute('data-next-url');
            if (newNextUrl) {
              this.loadMoreBtn.setAttribute('data-next-url', newNextUrl);
            } else {
              this.hideLoadMoreBtn();
            }
          } else {
            this.hideLoadMoreBtn();
          }
        } catch (error) {
          console.error('Error loading more articles:', error);
        } finally {
          this.loadMoreBtn.classList.remove('is-loading');
          this.loadMoreBtn.disabled = false;
        }
      }

      hideLoadMoreBtn() {
        this.loadMoreBtn.style.display = 'none';
      }
    }
  );
}
